import { render, staticRenderFns } from "./SongEdit.vue?vue&type=template&id=2e35ed6f&"
import script from "./SongEdit.vue?vue&type=script&lang=js&"
export * from "./SongEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e35ed6f')) {
      api.createRecord('2e35ed6f', component.options)
    } else {
      api.reload('2e35ed6f', component.options)
    }
    module.hot.accept("./SongEdit.vue?vue&type=template&id=2e35ed6f&", function () {
      api.rerender('2e35ed6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SongEdit.vue"
export default component.exports